import { Check } from "lucide-react";
import { Button } from "@bookdental/ui";

type Props = {
  dirty: boolean;
  isPending: boolean;
  onSave: () => void;
  /** Separa "dá pra salvar" de "você mexeu em algo". Onde a tela abre com um valor sugerido já
   *  marcado, salvar faz sentido de cara, mas avisar de alteração pendente sem ninguém ter tocado
   *  em nada é alarme falso. Sem isso, segue o `dirty`. */
  avisar?: boolean;
};

export function TabSaveBar({ dirty, isPending, onSave, avisar }: Props) {
  return (
    <div className="flex items-center justify-end gap-3 border-t border-zinc-100 pt-4">
      {(avisar ?? dirty) && (
        <span className="inline-flex items-center gap-1.5 text-xs text-amber-700">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
          Alterações não salvas
        </span>
      )}
      <Button onClick={onSave} disabled={!dirty || isPending} className="h-10">
        <Check className="h-4 w-4" />
        {isPending ? "Salvando..." : "Salvar"}
      </Button>
    </div>
  );
}
